const Lang = require('lang');

(function ($) {


  const defaults = {
      'displayIcon': true,
      // DESC     : Should we display the icon or not.
      // VALUE    : true or false // TYPE     : Boolean

      'iconClass': 'fa fa-refresh fa-spin',
      // DESC     : Class name of the font awesome icons", Currently we use font-awesome for default value.
      // VALUE    : (Icon Class Name)
      // TYPE     : String


      'title': Lang.get('js/functions.loading'),
      // DESC     : Overlay title
      // TYPE     : String

      'desc': '',
      // DESC     : Descrition
      // TYPE     : String
      //

      fixed: false,


    },
    uID = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    methods = {
      'show': function (el) {
        const target = $(el),
          ovId = 'nifty-overlay-' + uID() + uID() + '-' + uID(),
          panelOv = $('<div id="' + ovId + '" class="panel-overlay ' + target.data('overlayFixed') + ' text-dark"></div>');

        el.prop('disabled', true).data('overlayId', ovId);
        target.addClass('panel-overlay-wrap');
        panelOv.appendTo(target).html(el.data('overlayTemplate'));
        return true;
      },
      'hide': function (el) {
        const target = $(el);
        const boxLoad = $('#' + el.data('overlayId'));

        if (boxLoad.length) {
          el.prop('disabled', false);
          target.removeClass('panel-overlay-wrap');
          boxLoad.hide().remove();
          return true;
        }

        return false;
      }
    },
    loadBox = function (el, options) {
      const opt = $.extend({}, defaults, options);
      const icon = (opt.displayIcon) ? '<span class="panel-overlay-icon"><i class="' + opt.iconClass + '"></i></span>' : '';
      const fixedClass = opt.fixed ? 'overlay-fixed' : '';

      el.data('overlayFixed', fixedClass);

      el.data('overlayTemplate', '<div class="panel-overlay-content ' + opt.fixed + 'pad-all unselectable">' + icon + '<h4 class="panel-overlay-title">' + opt.title + '</h4><p>' + opt.desc + '</p></div>');
      return null;
    };

  $.fn.overlay = function (method) {
    if (methods[method]) {
      return methods[method](this);
    } else if (typeof method === 'object' || !method) {
      return this.each(function () {
        loadBox($(this), method);
      });
    }
    return null;
  };


}(jQuery));

